import QuestionObj from '../Models/QuestionObj';

const VirtualSeller_QSet = [    
    new QuestionObj({
        questionSet:{
        English: 'Is AI built into your applications to automate and simplify the sales process?',
        German: 'German Q1',
        French: "French Q1",
        Russian: "Russian Q1",
        Turkish: "Turkish Q1",
        Italian: "Italian Q1",
        Spanish: "Spanish Q1",
        PortugueseBR: "PortugueseBR Q1",
        SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                'No, we don’t have any AI in our applications',
                'We use AI in our applications, but our AI capabilities are an add-on, not built in ',
                'Yes, we use built-in AI in our applications ',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,66, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Does your CRM use digital tools, such as intelligent recommendations, to guide the sales experience?',
            German: 'German Q2',
            French: "French Q2",
            Russian: "Russian Q2",
            Turkish: "Turkish Q2",
            Italian: "Italian Q2",
            Spanish: "Spanish Q2",
            PortugueseBR: "PortugueseBR Q2",
            SpanishLAD: "SpanishLAD Q2",
        },
        answerSet:{
            English: [
                'No, sellers use different systems and applications to manually move the sales process forward',
                'Somewhat',
                'Yes, our CRM has embedded digital tools that guide sellers through the sales process',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
    new QuestionObj({
                questionSet: {
                    English: 'Does your CRM improve seller productivity by providing relevant and reliable customer data whenever sellers need it?',
                    German: 'German Q3',
                    French: "French Q3",
                    Russian: "Russian Q3",
                    Turkish: "Turkish Q3",
                    Italian: "Italian Q3",
                    Spanish: "Spanish Q3",
                    PortugueseBR: "PortugueseBR Q3",
                    SpanishLAD: "SpanishLAD Q3",
                },

                answerSet: {
                    English: [
                        'No, sellers often complain that they waste time with manual processes in an unreliable CRM',
                        'Our CRM has the tools and resources needed to improve seller productivity, but the data in these tools is often outdated, so sellers don’t trust it',
                        'Somewhat, sellers use our CRM system, but we hear mixed reviews about how useful it is',
                        'Yes, our CRM improves sellers’ productivity and satisfaction with helpful tools and an intuitive interface',                        
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
                },
                custVals: [25, 50, 75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you offer a mobile application that gives sellers the ability to access their CRM from anywhere?',
            German: 'German Q4',
            French: "French Q4",
            Russian: "Russian Q4",
            Turkish: "Turkish Q4",
            Italian: "Italian Q4",
            Spanish: "Spanish Q4",
            PortugueseBR: "PortugueseBR Q4",
            SpanishLAD: "SpanishLAD Q4",
        },
        answerSet:{
            English: [
                'No',
                'Yes',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,100],
    }),
  new QuestionObj({
        questionSet:{
            English: 'Are you able to collect and connect data from multiple systems and applications to get a holistic view of your customers?',
            German: 'German Q5',
            French: "French Q5",
            Russian: "Russian Q5",
            Turkish: "Turkish Q5",
            Italian: "Italian Q5",
            Spanish: "Spanish Q5",
            PortugueseBR: "PortugueseBR Q5",
            SpanishLAD: "SpanishLAD Q5",
        },
        answerSet:{
            English: [
                'No',
                'Some of our systems are integrated',
                'Most, but not all our systems are integrated, and the data is not up to date',
                'Yes, all systems are integrated, and data is up to date',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50,75,100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Are your marketing and sales applications integrated to deliver a seamless customer experience?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                'No, our applications are disconnected, limiting seller visibility into marketing activities ',
                'Some of our applications are connected, but not all',
                'Yes, our applications are connected, and sellers have full visibility into marketing activities. ',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
];

export default VirtualSeller_QSet;